const intersect = (pool, c) => {
  for (let b of pool) {
    if ((c[0] <= b[1] && c[0] >= b[0]) || (c[1] <= b[1] && c[1] >= b[0])) {
      return true
    }
  }
  return false
}

const isNumber = value => typeof value === 'number' && !isNaN(value)

const isValidScore = d => {
  if (!d[0] && !d[1]) {
    return true
  } else if (isNumber(d[0]) && isNumber(d[1])) {
    return true
  } else {
    return false
  }
}

export default {
  props: ['value', 'view'],
  data() {
    return {
      data: [],
      columns: [{
          type: 'index',
          width: 65,
          title: '序号',
          align: 'center'
        },
        {
          title: '预警等级',
          key: 'name',
          minWidth: 120,
        },
        {
          title: '预警颜色',
          key: 'color',
          minWidth: 100,
          render(h, { row }) {
            return <ColorPicker value={row.color} />
          }
        },
        {
          title: '车辆工作占比(%)',
          key: 'scoreMin',
          minWidth: 100,
          render: (h, { row, index }) => {
            let node = []
            if (row.scoreMin || row.scoreMax) {
              node.push(<span style="display:inline-block;width:70px;">{row.scoreMin} ~ {row.scoreMax}</span>)
            } else {
              node.push(<span style="display:inline-block;width:70px;">尚未设置</span>)
            }

            if (this.view) {
              return node
            } else {
              node.push(<a style="margin-left:8px"><Icon size={20} type="ios-create-outline" /></a>)
              return <ScoreSetter scoreMin={row.scoreMin} scoreMax={row.scoreMax} filter={(nv) => this.scoreFilter(nv , index)} on-change={(nv) => this.handleChange(nv , index)}>
                { node }
              </ScoreSetter>
            }

          }
        },

      ]
    }
  },
  created() {
    this.$watch('value', function(nv) {
      if (nv && Array.isArray(nv) ) {
        this.data = nv.map(i => ({
          level:i.level,
          scoreMin: i.scoreMin,
          scoreMax: i.scoreMax,
          name: i.name,
          color: i.color
        }))
      }
    }, { immediate: true })
  },
  methods: {
    emit() {
      let publicData = this.data.map(i => ({ ...i }))
      this.$emit('input', publicData)
    },

    scoreFilter(nv, idx) {
      if (!isValidScore(nv)) {
        this.$Message.error('请输入完整')
        return true
      } else {
        let d = this.data.filter((i, j) => j !== idx && (i.scoreMin || i.scoreMax)).map(i => ([i.scoreMin, i.scoreMax]))
        if (intersect(d, nv)) {
          this.$Message.error('不能与已有分值重复')
          return true
        }
      }

    },
    handleChange(nv, idx) {
      let hit = this.data[idx]
      hit.scoreMin = nv[0]
      hit.scoreMax = nv[1]

      this.data.splice(idx, 1, hit)

      this.emit()
    }
  },
  render() {
    return <div>
      <sl-table page={false} columns={this.columns} data={this.data} />
    </div>
  }
}

const ColorPicker = {
  props: ['value'],
  render() {
    return <div style={{width:"24px",height:"24px","backgroundColor":this.value || '#000000'}}></div>
  }
}

const ScoreSetter = {
  props: ['scoreMin', 'scoreMax', 'filter'],
  data() {
    return {
      visible: false,
      currentMin: null,
      currentMax: null,
    }
  },
  created() {
    this.currentMin = this.scoreMin !== undefined ? this.scoreMin : null
    this.currentMax = this.scoreMax !== undefined ? this.scoreMax : null
  },
  methods: {
    onOk() {
      let d = [this.currentMin, this.currentMax]

      if (this.filter && typeof this.filter === 'function') {
        let process = this.filter(d)
        Promise.resolve(process).then(err => {
          console.log(err, 'error')
          if (!err) {
            this.$emit('change', d)
            this.visible = false
          }
        })
      } else {
        this.$emit('change', d)
        this.visible = false
      }
    }
  },
  render() {
    const { $scopedSlots } = this
    const slots = {
      default: () => {
        return $scopedSlots.default ? $scopedSlots.default() : null
      },
      content: () => {
        return (
          <div style="padding:8px;">
            <div>
              <InputNumber min={0} max={this.currentMax || 100} active-change={false} parser={ value => value.split('.')[0] } vModel={this.currentMin} placeholder="最小占比"  />
              <span class="sl-search-combo-divider"> ~ </span>
              <InputNumber min={this.currentMin || 0} active-change={false} parser={ value => value.replace(/[^\d]/g, '') } vModel={this.currentMax} max={100} placeholder="最大占比" />
            </div>
            <div class="flex" style="margin-top:8px;">
              <Button size="small" type="primary" on-click={this.onOk}>确定</Button>
            </div>
          </div>
        )
      }
    }
    //RangeTimePickerPanel
    return <Poptip on-on-popper-hide={()=>{this.visible = false}} on-on-popper-show={()=>{this.visible=true}} padding="0" value={this.visible} transfer={true} scopedSlots={slots}>
    </Poptip>
  }
}